import { render, staticRenderFns } from "./agreement_academics.vue?vue&type=template&id=642c68be"
import script from "./agreement_academics.vue?vue&type=script&lang=js"
export * from "./agreement_academics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports